<template>
  <div class="chat-message" :class="messageClasses">
    <div v-if="message.system" class="chat-message__system-notification">
      <div
        class="chat-message__system-notification-text"
        v-html="message.txt"
      ></div>
      <div class="chat-message__system-notification-date">
        ({{ getTime(message.date) }})
      </div>
    </div>

    <template v-else>
      <div class="chat-message__avatar">
        <avatar :img="message.avatar" clean />
      </div>

      <div class="chat-message__main">
        <v-tooltip :disabled="!isAbsent(message.identity)" right>
          <template v-slot:activator="{ on }">
            <div class="chat-message__content" v-on="on">
              <div class="chat-message__content-header">
                <template v-if="!showMessageRecipient(message)">
                  {{ message.self ? 'You' : message.name }}
                </template>

                <template v-else>
                  <message-recipient
                    :name="message.name"
                    :identity="message.identity"
                    :isAbsent="isAbsent"
                    @select="initDirectMessage"
                  />
                  to
                  <message-recipient
                    :name="message.recipient.text"
                    :identity="message.recipient.value"
                    :isAbsent="isAbsent"
                    @select="initDirectMessage"
                  />
                </template>
              </div>
              <span v-html="prepareText(message.txt)"></span>
            </div>
          </template>

          <span>Participant is no longer present</span>
        </v-tooltip>

        <div class="chat-message__date" v-if="message.date">
          {{ getDate(message.date) }}
          <v-icon
            v-if="showReplyButton"
            class="reply-icon"
            @click="initDirectMessage(message.identity)"
          >
            reply
          </v-icon>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from 'date-fns';
import linkifyHtml from 'linkify-html';

import Avatar from '@/components/basic/avatar/Avatar';
import MessageRecipient from '@/components/rooms/components/roomChat/MessageRecipient';
import { mapState } from 'vuex';

export default {
  name: 'RoomChatMessage',
  components: {
    Avatar,
    MessageRecipient,
  },
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    isAbsent: Function,
  },
  computed: {
    showReplyButton() {
      const { identity } = this.message;
      if (identity === this.roomInfo?.identity) return false;
      return !this.isAbsent(identity);
    },

    messageClasses() {
      const { system, self, identity } = this.message;

      return {
        right: self && !system,
        missing: this.isAbsent(identity),
        system: system,
      };
    },
  },
  methods: {
    ...mapState('rooms', ['roomInfo']),

    getDate(date) {
      return format(new Date(date), 'MMM do, h:mm aaa');
    },

    getTime(date) {
      return format(new Date(date), 'h:mm aaa');
    },

    showMessageRecipient(message) {
      return message?.recipient?.value;
    },

    prepareText(text) {
      return linkifyHtml(text, {
        defaultProtocol: 'https',
        target: '_blank',
      });
    },

    initDirectMessage(data) {
      this.$emit('initDirectMessage', data);
    },
  },
};
</script>
